"use client";

import { CommandGroup, CommandItem } from "@/components/ui/command";
import { useTranslations } from "next-intl";
import { CheckIcon } from "lucide-react";
import Image from "next/image";
import { SelectedAreaItem } from "../LocationOptionItems";
import type { SelectedLocationDisplayProps } from "./types";

export function SelectedLocationDisplay({
  customLocation,
  currentArea,
  countryOptions,
}: SelectedLocationDisplayProps) {
  const t = useTranslations();
  const yourLocation = t("locationSelector.yourLocation");
  const name = customLocation?.displayName || yourLocation;

  return (
    <CommandGroup heading={t("locationSelector.selected")}>
      {customLocation ? (
        <CommandItem className="flex items-center gap-3 px-2 py-3 bg-transparent data-[selected=true]:bg-transparent">
          <div className="relative shrink-0">
            <Image
              src="/search/search-custom.png"
              alt={name}
              width={40}
              height={40}
              className="rounded-sm"
              sizes="40px"
              onError={(e) => {
                e.currentTarget.style.display = "none";
              }}
            />
          </div>
          <div className="flex flex-col gap-0.5 flex-1 min-w-0">
            <span className="font-medium text-base leading-6 truncate">
              {name}
            </span>
            {customLocation.secondaryText && (
              <span className="text-sm text-muted-foreground leading-5 truncate">
                {customLocation.secondaryText}
              </span>
            )}
          </div>
          <CheckIcon className="size-5 text-foreground shrink-0" />
        </CommandItem>
      ) : (
        <SelectedAreaItem area={currentArea} options={countryOptions} />
      )}
    </CommandGroup>
  );
}
